
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import { CarouselPaginationType, CarouselSlotName } from '@/ui-kit/components/carousel/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import Carousel from '@/ui-kit/components/carousel';
import IconButton from '@/ui-kit/components/icon-button';
import WhoWeAreStoreName from '@/store/who-we-are/name';
import WhoWeAreCarouselItem from './carousel-item';
import { CAROUSEL_HEIGHT } from './constants';

export default {
  name: 'WhoWeAreFooterSection',
  components: {
    Carousel,
    WhoWeAreCarouselItem,
    IconButton,
  },
  data() {
    return {
      activeIndex: 0,
      CAROUSEL_HEIGHT,
      StyleColorSchemeType,
      StyleSizeType,
      CarouselPaginationType,
      CarouselSlotName,
      IconType,
    };
  },
  computed: {
    footerContent() {
      return this.$store.state[WhoWeAreStoreName].footerContent;
    },
  },
  methods: {
    handleScroll(index) {
      this.activeIndex = index;
    },
    getIsActive(index) {
      return index === this.activeIndex;
    },
  },
};
